<template>
  <div class="layout-builder-layout-placeholder-notepad">
    <div
      v-for="i in PLACEHOLDER_SAMPLES"
      :key="i"
      class="layout-builder-layout-placeholder-notepad-item"
    >
      <div class="layout-builder-layout-placeholder-notepad-item-top">
        <div class="layout-builder-layout-placeholder-notepad-item-top-line" />
        <div class="layout-builder-layout-placeholder-notepad-item-top-square" />
      </div>
      <div class="layout-builder-layout-placeholder-notepad-item-bottom">
        <div class="layout-builder-layout-placeholder-notepad-item-bottom-line" />
        <div class="layout-builder-layout-placeholder-notepad-item-bottom-square" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'LayoutBuilderLayoutPlaceholderNotepad',
  setup() {
    const PLACEHOLDER_SAMPLES = 50;

    return {
      PLACEHOLDER_SAMPLES,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../../styles/index";

.layout-builder-layout-placeholder-notepad {
  @include placeholder;

  $root: &;

  width: 100%;
  height: 100%;
  gap: var(--s-6);

  &-item {
    display: flex;
    flex-direction: column;
    gap: var(--s-4);

    > * {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    &-top {
      &-line {
        @include placeholder-line-primary;

        flex: 0 1 6.5625rem;
      }

      &-square {
        @include placeholder-line-secondary;

        flex: 0 0 1.125rem;
      }
    }

    &-bottom {
      gap: 3.375rem;

      &-line {
        @include placeholder-line-secondary;

        flex: 1 1 auto;
      }

      &-square {
        @include placeholder-line-secondary;

        flex: 0 0 1.125rem;
      }
    }
  }
}
</style>
